import { AxiosResponse } from "axios";
import axios, { APIWrapperResponse, DefaultResponse } from "../general/HttpClient";
import { MatchViewModel } from "../matches/MatchesStore";
import { SeasonViewModel, TeamStatisticsViewModel } from "../seasons/SeasonsStore";
import { TeamViewModel } from "../teams/TeamsStore";

export function getLeagues(archived) {
    return axios.get("/api/leagues/getLeagues", { params: { archived } }).then((response: AxiosResponse<APIWrapperResponse<Array<LeagueViewModel>>>) => {
        return response.data.result;
    });
}

export function getTeamLeagues(id) {
    return axios.get(`/api/leagues/getTeamLeagues/${id}`).then((response: AxiosResponse<APIWrapperResponse<Array<LeagueViewModel>>>) => {
        return response.data.result;
    });
}

export function getAliasLeagues(id) {
    return axios.get(`/api/leagues/getAliasLeagues/${id}`).then((response: AxiosResponse<APIWrapperResponse<Array<LeagueViewModel>>>) => {
        return response.data.result;
    });
}

export function getLeague(id, includeArchivedSeasons = false) {
    return axios.get(`/api/leagues/getLeague/${id}`, { params: { includeArchivedSeasons } }).then((response: AxiosResponse<APIWrapperResponse<LeagueViewModel>>) => {
        return response.data.result;
    });
}

export function createLeague(request: CreateLeagueRequest) {
    return axios.post(`/api/leagues/createLeague`, request).then((response: AxiosResponse<APIWrapperResponse<CreateLeagueResponse>>) => {
        return response.data.result;
    });
}

export function updateLeague(request: LeagueViewModel | UpdateLeagueRequest) {
    return axios.put(`/api/leagues/updateLeague`, request).then((response: AxiosResponse<APIWrapperResponse<DefaultResponse>>) => {
        return response.data.result;
    });
}

export class LeagueViewModel {
    constructor() {
        this.seasons = [];
    }
    id?: string;
    name: string;
    rules: string;
    rulesAsMarkdown: boolean;
    logoUri: string;
    splashUri: string;
    color: string;
    locked?: boolean;
    isPublic?: boolean;
    archived?: boolean;
    seasons?: SeasonViewModel[];
    teamStatistics?: TeamStatisticsViewModel[];
}

export class CreateLeagueRequest {
    organizationID: string;
    name: string;
    rules: string;
    rulesAsMarkdown: boolean;
    logoUri: string;
    logoContent: string;
    splashUri: string;
    splashContent: string;
    color: string;
    isPublic: boolean;
}

export interface CreateLeagueResponse extends DefaultResponse {
    leagueID: string;
}

export interface UpdateLeagueRequest {
    id: string;
    name: string;
    rules: string;
    rulesAsMarkdown: boolean;
    logoUri: string;
    logoContent: string;
    splashUri: string;
    splashContent: string;
    color: string;
    isPublic: boolean;
    bracketType: string;
}
